
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/przewidywana-data-otwarcia-osrodkow",
      function () {
        return require("private-next-pages/[region]/przewidywana-data-otwarcia-osrodkow.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/przewidywana-data-otwarcia-osrodkow"])
      });
    }
  